import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { HowItWorks } from './components/HowItWorks';
import { VideoSection } from './components/VideoSection';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Features data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <VideoSection data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Pricing data-id="element-7" />
      <CTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}